<div ng-controller="competencyCatalogNodeGeneralController as compCatNodeCtrl">
    <c-auto-form config="compCatNodeCtrl.autoFormConfig"></c-auto-form>
</div>